
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import FaqSection from '~/components/sections/faq/FaqSection.vue'
import { FAQItem } from '~/composables/seo.composable'

type ContextType = 'index' | 'internet-plans' | 'mobile-plans' | 'swisscom' | 'salt' | 'wingo' | 'yallo' | 'migros-mobile' | 'quickline' | 'talktalk' | 'spusu' | 'mtel'

@Component({
  components: {
    FaqSection,
  },
})
class BFFaq extends Vue {
  @Prop({
    type: String,
    default: 'index',
  })
  context!: ContextType

  get faqTitle (): string {
    return this.$t(`blackFriday.faq.${this.context}.title`) as string || this.$t('blackFriday.faq.title') as string
  }

  get faqItems (): FAQItem[] {
    return (this.$t(`blackFriday.faq.${this.context}.items`) || this.$t('blackFriday.faq.index.items')) as unknown as FAQItem[]
  }
}

export default BFFaq
